<template>
  <v-card class="pa-6 pb-2">
    Editar Producto de la Venta {{ editedDetail.quotation_id }}

    <v-row class="ma-0 mt-4">
      <v-col ols="12" sm="4" md="2" class="py-0 my-0">
        <v-text-field v-model="editedDetail.quantity" label="Cantidad"></v-text-field>
      </v-col>

      <v-col ols="12" sm="8" md="4" class="py-0 my-0">
        <v-autocomplete
          item-text="name"
          v-model="editedDetail.item_id"
          item-value="id"
          label="Producto"
          clearable
          :items="productsList"
          :loading="isLoadingProducts"
          :search-input.sync="searchProducts"
          placeholder="Escribe para buscar o crear"
          hide-no-data
        >
          <template v-slot:item="{ item, attrs, on }">
            <v-list-item v-on="on" v-bind="attrs">
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.name }} |
                  {{ (item.price * 1).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' }) }}
                  <div>
                    <span style="font-size:14px;">Inventario:
                      <strong v-if="item.inventory < 1" style="color:red!important;">{{ item.inventory }}</strong>
                      <strong v-else style="color:green!important;">{{ item.inventory }}</strong>
                    </span>
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="8" md="3" class="py-0 my-0">
        <v-text-field v-model="editedDetail.price" prefix="$" suffix="c/u" label="Precio"></v-text-field>
      </v-col>

      <v-col cols="12" sm="8" md="3" class="py-0 my-0">
        <v-text-field
          :value="editedDetail.price - ((editedDetail.price/100) * editedDetail.discount)"
          disabled prefix="$" suffix="c/u" label="Precio Ajustado" type="number">
        </v-text-field>
      </v-col>
    </v-row>

    <v-card-actions>
      <v-spacer class="hidden-md-and-down"></v-spacer>
      <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
      <v-btn color="blue darken-1" text @click="save" :loading="gris" :disabled="gris">Guardar</v-btn>
    </v-card-actions>

    <v-snackbar :color="snackbar.color" v-model="snackbar.show">
      {{ snackbar.message }}
    </v-snackbar>
  </v-card>
</template>

<script>
import axios from "axios"
export default {
  props: {
    editedDetail: Object
  },
  data: () => ({
    gris: false,
    snackbar: {
      show: false,
      message: null,
      color: null
    },
    entries: {
      products: []
    },
    isLoadingProducts: false,
    searchProducts: null,
  }),
  computed: {
    liga() {
      return process.env.VUE_APP_BACKEND_ROUTE
    },
    productsList() {
      return this.entries.products
    },
    currentCost() {
      // costo del producto seleccionado
      return Number(this.productsList.find(p => p.id === this.editedDetail.item_id)?.cost) || 0
    },
    clientPct() {
      return Number(this.editedDetail.price_list) || 0
    }
  },
  watch: {
    // Buscar productos por texto
    searchProducts(val) {
      if (this.isLoadingProducts) return
      this.isLoadingProducts = true
      axios.get(process.env.VUE_APP_BACKEND_ROUTE + 'api/v2/item/pos?filter[is_published]=1&filter[pos]=' + val)
        .then(res => {
          this.entries.products = res.data.data
        })
        .finally(() => (this.isLoadingProducts = false, this.search = false))
    },

    // Cuando cambias el producto: trae el costo y recalcula
    'editedDetail.item_id': {
      async handler() {
        await this.getProduct()
        this.recalcPrice()
      }, deep: true
    },

    // Si cambia el % de lista también recalcula
    'editedDetail.price_list': {
      handler() {
        this.recalcPrice()
      }, deep: true
    }
  },
  methods: {
    // ---- Helpers de redondeo y cálculo ----
    roundPesos(n) {
      // .50 para arriba, .49 para abajo => redondeo a entero
      return Math.round(Number(n) || 0)
    },
    computePrice(cost, pct) {
      // MF: cost / (1 - pct/100)  |  Otros: cost * (1 + pct/100)
      const c = Number(cost) || 0
      const p = Number(pct) || 0
      if (!c) return 0
      const raw = (this.liga === 'https://backendmf.unocrm.mx/')
        ? c / (1 - p / 100)
        : (c * (1 + p / 100))
      // redondea a pesos y deja 2 decimales para UI
      return this.roundPesos(raw)
    },
    recalcPrice() {
      if (!this.editedDetail?.item_id) return
      const priceRounded = this.computePrice(this.currentCost, this.clientPct)
      this.editedDetail.price = Number(priceRounded).toFixed(2)
    },
    // ---------------------------------------

    close() {
      this.gris = false
      this.$nextTick(() => {
        this.$emit("closeDialogEditDetail", false);
      })
    },
    save() {
      this.editedDetail.quantity = this.editedDetail.quantity * 1
      this.gris = true
      const sale_item_to_save = [this.editedDetail].map(item => {
        return {
          ...item,
          price: item.price - ((item.price / 100) * item.discount),
          discount: item.discount * 1
        }
      })[0]
      this.$nextTick(() => {
        axios.put(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/sale_items/" + sale_item_to_save.id, sale_item_to_save)
          .then(() => this.close())
          .catch(error => {
            this.snackbar = {
              message: error.response.data.message,
              color: 'error',
              show: true
            }
            this.gris = false
            this.close()
          })
      })
    },
    getProduct() {
      if (!this.editedDetail?.item_id) return
      this.isLoadingProducts = true
      return axios
        .get(process.env.VUE_APP_BACKEND_ROUTE + 'api/v2/item/pos?filter[id]=' + this.editedDetail.item_id)
        .then(res => {
          this.entries.products = res.data.data
        })
        .finally(() => (this.isLoadingProducts = false, this.search = false))
    }
  },
  async created() {
    await this.getProduct()
    this.recalcPrice()
  },
  async mounted() {
    await this.getProduct()
    this.recalcPrice()
  }
}
</script>

<style>
</style>
